export const checkNodeEnv = (nodeEnv: string = 'development'): boolean => {
  return process.env.NODE_ENV === nodeEnv;
};
